import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

export const title = "Réglementation DIREN"

export const SidebarData = [
  /*
  {
    title: "Home",
    path: "/home",
    icon: <IoIcons.IoIosBoat />,
    cName: "nav-text",
  },
  */
  {
    title: "Administration",
    path: "/administration",
    icon: <RiIcons.RiAdminFill />,
    cName: "nav-text",
  },
];

export const SideBarProfile = [
  {
    title: "Profil",
    path: "/profil",
    icon: <RiIcons.RiAccountCircleFill />,
    cName: "nav-text",
  }
]
